module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"warning":"Page not found"},"ro":{"warning":"OM LA APĂ? Se pare că te-ai pierdut. Iată câteva pagini pe care ți le putem sugera."}}')
  delete Component.options._Ctor
}
